import styled from 'styled-components';
import { Modal } from 'antd';

export const MapBuilderPopupContainer = styled(Modal)`
  .ant-modal-content {
    margin: 0 auto;
    background-color: ${({ theme: { token } }) => token.colorBgBase};
    padding: 0 !important;
  }

  .modal-header-svg {
    margin: 0;
    padding: 0;
    display: block;
    font-size: 0;

    svg {
      height: 200px;
      display: block;
      margin: 0;
      padding: 0;
    }
  }

  .modal-title {
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    padding: 0 ${({ theme: { token } }) => token.paddingMD}px;
    padding-bottom: ${({ theme: { token } }) => token.paddingMD}px;
    //text-align: center;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .modal-subtitle {
    display: block;
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    padding: 0 ${({ theme: { token } }) => token.paddingLG}px;
    text-align: left;
    color: ${({ theme: { token } }) => token.colorText};
  }

  .popup-content {
    text-align: left;
    margin-bottom: ${({ theme: { token } }) => token.marginLG}px;
    padding: 0 ${({ theme: { token } }) => token.paddingLG}px ${({ theme: { token } }) => token.paddingLG}px;

    .update-list {
      color: ${({ theme: { token } }) => token.colorTextSecondary};
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      list-style: none;
      font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
      padding: 0;
      margin: 0 0 ${({ theme: { token } }) => token.marginLG}px 0;
      line-height: ${({ theme: { token } }) => token.lineHeightLG};

      li {
        position: relative;
        padding-left: ${({ theme: { token } }) => token.paddingSM}px;
        margin-left: ${({ theme: { token } }) => token.marginXS}px;
        color: ${({ theme: { token } }) => token.colorTextSecondary};

        &::before {
          content: '•';
          position: absolute;
          left: 0;
          color: ${({ theme: { token } }) => token.colorNeutral};
          font-weight: bold;
        }
      }
    }

    .closing-message {
      text-align: center;
      margin: ${({ theme: { token } }) => token.marginXL}px 0;
      font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
      color: ${({ theme: { token } }) => token.colorText};
    }

    .button-container {
      display: flex;
      justify-content: center;
      margin-top: ${({ theme: { token } }) => token.marginXL}px;

      .ant-btn-primary {
        background: ${({ theme: { token } }) => token.colorPrimary};
        color: ${({ theme: { token } }) => token.solidTextColor};
        border: none;
        border-radius: ${({ theme: { token } }) => token.borderRadius}px;
        padding: ${({ theme: { token } }) => token.paddingSM}px ${({ theme: { token } }) => token.paddingLG}px;
        font-size: ${({ theme: { token } }) => token.fontSize}px;
        font-weight: ${({ theme: { token } }) => token.fontWeightNormal};
      }
    }
  }
`;
